"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _is = require("@utiljs/is");

var _Popover = _interopRequireDefault(require("../core/Popover"));

var _DropMenuItem = _interopRequireDefault(require("./DropMenuItem"));

var _DropMenuDivider = _interopRequireDefault(require("./DropMenuDivider"));

var _DropMenuList = _interopRequireDefault(require("./DropMenuList"));

var _types = require("../_utils/types");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DropMenu = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(DropMenu, _React$PureComponent);

  var _super = _createSuper(DropMenu);

  function DropMenu() {
    var _this;

    (0, _classCallCheck2.default)(this, DropMenu);
    _this = _super.apply(this, arguments);

    _this.handleMenuItemClick = function (item) {
      var onItemClick = _this.props.onItemClick;

      if ((0, _is.isFunction)(onItemClick)) {
        onItemClick(item);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(DropMenu, [{
    key: "renderMenu",
    value: function renderMenu(menuData) {
      var _this2 = this;

      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className;

      if (!menuData) {
        return null;
      }

      return /*#__PURE__*/React.createElement(_DropMenuList.default, {
        style: style,
        className: className
      }, menuData.map(function (item, index) {
        if (item === '') return /*#__PURE__*/React.createElement(DropMenu.Divider, {
          key: index
        });

        if (typeof item === 'string') {
          return /*#__PURE__*/React.createElement(_DropMenuItem.default, {
            label: item,
            key: item,
            onMenuClick: _this2.handleMenuItemClick
          });
        }

        return /*#__PURE__*/React.createElement(_DropMenuItem.default, (0, _assign.default)({}, item, {
          key: index,
          onMenuClick: _this2.handleMenuItemClick
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          trigger = _this$props2.trigger,
          visible = _this$props2.visible,
          defaultVisible = _this$props2.defaultVisible,
          placement = _this$props2.placement,
          onVisibleChange = _this$props2.onVisibleChange,
          menu = _this$props2.menu,
          menuComponent = _this$props2.menuComponent,
          popupContainer = _this$props2.popupContainer,
          isSubMenu = _this$props2.isSubMenu,
          popupClassName = _this$props2.popupClassName,
          flip = _this$props2.flip,
          onClickOutside = _this$props2.onClickOutside;
      return /*#__PURE__*/React.createElement(_Popover.default, {
        disablePortal: isSubMenu,
        visible: visible,
        container: popupContainer,
        defaultVisible: defaultVisible,
        trigger: trigger,
        placement: placement,
        display: "inline-block",
        flip: flip,
        onClickOutside: onClickOutside,
        onVisibleChange: onVisibleChange,
        className: popupClassName,
        content: menuComponent || this.renderMenu(menu)
      }, children);
    }
  }]);
  return DropMenu;
}(React.PureComponent);

DropMenu.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string
  }), PropTypes.string])),
  placement: PropTypes.oneOf(_types.innerPlacement),
  trigger: PropTypes.oneOf(['hover', 'click']),
  flip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onItemClick: PropTypes.func,
  onClickOutside: PropTypes.func,
  className: PropTypes.string,
  popupClassName: PropTypes.string,
  popupContainer: PropTypes.func,
  isSubMenu: PropTypes.bool
};
DropMenu.defaultProps = {
  trigger: 'hover',
  placement: 'bottomLeft',
  menu: null,
  className: null,
  popupClassName: null,
  onItemClick: undefined,
  onClickOutside: undefined,
  flip: true,
  popupContainer: undefined,
  isSubMenu: false
};
DropMenu.Item = _DropMenuItem.default;
DropMenu.List = _DropMenuList.default;
DropMenu.Divider = _DropMenuDivider.default;
var _default = DropMenu;
exports.default = _default;